import type { IconSvgObject } from './types';

const MpFour01Icon: IconSvgObject = [
  ["path", { d: "M4 12.9978L4.01994 3.99557C4.02238 2.89186 4.91845 1.99877 6.02216 2L12.9958 2.00776L20 8.99481L19.9922 12.9978M13 2.49778V6.99778C13 8.10235 13.8954 8.99778 15 8.99778H19.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4 22V16L6 19L8 16V22M10.5 22V19.5M10.5 19.5V16H12.25C13.2165 16 14 16.7835 14 17.75C14 18.7165 13.2165 19.5 12.25 19.5H10.5ZM16.5 16V19H20M20 19V16M20 19V21.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default MpFour01Icon;
